export default "__VITE_ASSET__D5cmxAO8__"